import { render, staticRenderFns } from "./StoreStatistics.vue?vue&type=template&id=952e8834&scoped=true"
import script from "./StoreStatistics.vue?vue&type=script&lang=js"
export * from "./StoreStatistics.vue?vue&type=script&lang=js"
import style0 from "./StoreStatistics.vue?vue&type=style&index=0&id=952e8834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952e8834",
  null
  
)

export default component.exports